import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { cloneArray } from '../../functions/shared-functions';

@Component({
  selector: 'tm-multi-checkbox',
  templateUrl: './multi-checkbox.component.html',
  styleUrls: ['./multi-checkbox.component.scss']
})
export class MultiCheckboxComponent implements OnInit, OnChanges {

  @Input() options;
  @Input() id_property = 'id';
  @Input() title_property = 'title';
  @Input() form_group: UntypedFormGroup;
  @Input() form_control;
  @Input() label;
  @Input() data;
  @Input() actionListner;
  @Input() mandatory;
  @Input() disabled;
  @Input() enable_active;
  @Input() ng_class;
  @Input() design_pattern = 1;
  random_id = 'tm_multi_select_checkbox' + Math.floor((Math.random() * 10000) + 1) + Date.now();

  @Output() change = new EventEmitter<any>()
  constructor(
    private change_detector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }
  ngOnChanges(ev) {
    if (ev && ev.options) {
      this.options = cloneArray(ev.options.currentValue)
      // this.options = [...this.options, ...this.options]
    }
    if (ev && ev.data) {
      this.data = ev.data.currentValue;
      if (typeof this.data == "string") {
        try {
          this.data = JSON.parse(this.data);
          if (this.data && this.data.length) {
            let d = []
            this.data.forEach(data => {
              if (this.options && this.options.length) {
                this.options.forEach(option => {
                  if (option[this.id_property] == data) {
                    option.option_selected = true;
                    d.push(option)
                  }
                })
              }

            })
            this.options = cloneArray(this.options)
            this.change.emit(d);
          } else {
            this.change.emit([]);
          }
        }
        catch (err) {
          console.log(err)
        }
      }
      else {
        if (this.data && this.data.length) {
          let d = []
          this.data.forEach(data => {
            this.options.forEach(option => {
              if (option[this.id_property] == data) {
                option.option_selected = true;
                d.push(option)
              }
            })
          });
          this.options = cloneArray(this.options)
          this.change.emit(d);
        }
        else {
          if (this.options && this.options.length) {
            this.options.forEach(op => {
              op['option_selected'] = false;
            })
          }
          this.change.emit([]);
        }
      }
    }

  }
  onSelect(option, index) {
    option['option_selected'] = !option['option_selected'];
    let options = [];
    let ids = [];
    this.options.forEach(o => {
      if (o.option_selected) {
        options.push(o)
        ids.push(o[this.id_property]);
      }
    })
    if (this.form_group) {
      this.form_group.get([this.form_control]).patchValue(ids);
      // this.change.emit(options);
      // console.log(this.form_group.get([this.form_control]).value);
    }
  }
  action(option) {
    try {
      if (this.actionListner) {
        this.actionListner(option);
      }
    }
    catch (err) {

    }
  }
}
